import { Logo } from "@/components/Logo";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const HIGHLIGHTS = [
  "Architettura multi-tenant sicura e isolata",
  "Gestione utenti, ruoli e permessi granulari",
  "API key, audit log e integrazioni pronte",
  "Predisposto per WhatsApp Business Cloud API",
];

export function AuthLayout({ children, title, subtitle }) {
  return (
    <div className="flex min-h-screen bg-background">
      {/* Brand panel */}
      <div className="relative hidden w-1/2 flex-col justify-between overflow-hidden bg-slate-900 p-12 lg:flex">
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1610219542098-df1753da93bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMG1vZGVybiUyMG1pbmltYWwlMjBjb21tdW5pY2F0aW9uJTIwYmFja2dyb3VuZHxlbnwwfHx8Z3JlZW58MTc4NDIxNzk0N3ww&ixlib=rb-4.1.0&q=85')",
            backgroundSize: "cover", backgroundPosition: "center",
          }}
        />
        <div className="relative z-10">
          <div className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground">
              <span className="font-heading text-lg font-bold">C</span>
            </div>
            <div>
              <p className="font-heading text-lg font-semibold text-white">Connectivity</p>
              <p className="text-xs text-slate-400">Business messaging, connected.</p>
            </div>
          </div>
        </div>
        <div className="relative z-10 space-y-4">
          <h2 className="font-heading text-3xl font-semibold leading-tight text-white">
            La piattaforma per gestire le comunicazioni WhatsApp Business.
          </h2>
          <ul className="space-y-2.5">
            {HIGHLIGHTS.map((h) => (
              <li key={h} className="flex items-center gap-2.5 text-sm text-slate-300">
                <CheckCircle2 className="h-4 w-4 text-primary" /> {h}
              </li>
            ))}
          </ul>
        </div>
        <p className="relative z-10 text-xs text-slate-500">© 2026 Connectivity. Tutti i diritti riservati.</p>
      </div>

      {/* Form panel */}
      <div className="flex w-full flex-col items-center justify-center px-6 py-12 lg:w-1/2">
        <div className="w-full max-w-md">
          <div className="mb-8 lg:hidden">
            <Logo size="lg" showSub />
          </div>
          <div className="mb-8">
            <h1 className="font-heading text-2xl font-semibold tracking-tight sm:text-3xl">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
